<style>
#videoReportModal .v--modal-box.v--modal {
  min-height: 200px !important;
  min-width: 420px !important;
}
</style>

<template>
  <Modal
    modalName="videoReportModal"
    title="Wydrukuj kartę zadania"
    :buttons="['print2']"
    @print="print"
    @closed="closed()"
    :print__left="true"
    @opened="getDictValues()"
  >
    <v-form
      v-model="valid"
      ref="form"
    >
      <v-layout>
        <v-flex>
          <v-select
            :items="netTypes"
            no-data-text="Brak typów sieci"
            v-model="net_type"
            label="Typ sieci"
            :rules="typeRules"
          ></v-select>
        </v-flex>
      </v-layout>
    </v-form>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    valid: false,
    netTypes: [],
    net_type: undefined,
    typeRules: [v => !!v || "Wybierz typ sieci"]
  }),
  methods: {
    closed() {
      this.valid = false;
      this.net_type = undefined;
    },
    getDictValues() {
      let payload = {
        schema: 'aquagis',
        table: 'chambers_sewers',
        column: 'net_type'
      };
      this.$store.dispatch("getDictSTC", payload).then(r => {
        if(!r) {
          return;
        } else {
          this.netTypes = r.values
        }
      });
    },
    print() {
      if(this.$refs.form.validate()) {
        this.$root.$emit("printReport", ["video", this.oid, this.net_type]);
      }
    },
    openVideoReportSettings(id) {
      this.oid = id
    }
  },
  mounted() {
    this.$root.$on('openVideoReportSettings', this.openVideoReportSettings)
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/video/modals/VideoReportSettings.vue